<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalStockRecords",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "18. (a) When was your last annual stocktaking?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0LastAnnualStocktakingDateId",
					props: {
						suggest: {
							typeIncludes: "lastAnnualStocktakingDate"
						},
						createOptions: {
							type: "lastAnnualStocktakingDate",
							dataType: "string"
						}
					}
				},
				{
					label:
						"18. (b) Do you keep proper records of all sales purchased and transaction?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SalesTransactionKeptProperlyId",
					props: {
						suggest: {
							typeIncludes: "salesTransactionKeptProperly"
						},
						createOptions: {
							type: "salesTransactionKeptProperly",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
